export default function() {
  const search = document.querySelector('[data-search-mini]');

  if (!search) {
    return false;
  }

  const toggles = document.querySelectorAll('[data-search-mini-toggle]');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      if (toggle.dataset.searchMiniToggle === 'close') {
        search.classList.remove('is-open');
      } else {
        search.classList.toggle('is-open');
      }

      if (search.classList.contains('is-open')) {
        search.querySelector('input[type="text"]').focus();
      }
    });
  });
}
